import { Link } from 'react-router-dom';
import { Shield, Wallet } from 'lucide-react';

const companyDetails = [
  ['Juridische entiteit', 'Buybeez'],
  ['Vestigingsland', 'Nederland'],
  ['E-mail', 'budgettoppers@buybeez.nl'],
  ['KvK', '92484476'],
  ['BTW', 'NL004956879B14'],
  ['D-U-N-S', '494977417'],
];

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-border bg-white/95 backdrop-blur">
        <div className="mx-auto flex max-w-5xl items-center justify-between gap-4 px-4 py-4 sm:px-6 sm:py-5">
          <Link to="/" className="flex items-center gap-3 text-foreground">
            <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary text-primary-foreground">
              <Wallet className="h-5 w-5" />
            </div>
            <span className="font-heading text-lg font-bold">budgettoppers</span>
          </Link>
          <Link to="/" className="shrink-0 text-sm font-medium text-muted-foreground transition-colors hover:text-foreground">
            Terug naar home
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-5xl px-4 py-8 sm:px-6 sm:py-12">
        <div className="mb-6 flex items-start gap-4 rounded-3xl border border-border bg-white p-6 shadow-card sm:mb-10 sm:p-8">
          <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-primary/10 text-primary">
            <Shield className="h-6 w-6" />
          </div>
          <div className="min-w-0">
            <p className="mb-2 text-sm font-semibold uppercase tracking-[0.2em] text-primary">Privacy</p>
            <h1 className="font-heading text-3xl font-bold leading-tight text-foreground sm:text-4xl">Privacyverklaring</h1>
            <p className="mt-3 max-w-2xl text-base leading-7 text-muted-foreground">
              Deze pagina beschrijft op hoofdlijnen hoe budgettoppers omgaat met persoonsgegevens, accountgegevens
              en gebruiksdata binnen de dienst.
            </p>
          </div>
        </div>

        <div className="grid gap-6 lg:grid-cols-[1.7fr_1fr] lg:items-start">
          <article className="space-y-6 rounded-3xl border border-border bg-white p-6 shadow-card sm:p-8">
            <section className="space-y-3">
              <h2 className="font-heading text-xl font-semibold leading-tight sm:text-2xl">1. Welke gegevens we verwerken</h2>
              <p className="text-base leading-7 text-muted-foreground">
                Bij gebruik van budgettoppers kunnen onder meer accountgegevens, profielgegevens, financiële invoer,
                contractinformatie en supportverzoeken worden verwerkt voor het leveren van de dienst.
              </p>
            </section>

            <section className="space-y-3">
              <h2 className="font-heading text-xl font-semibold leading-tight sm:text-2xl">2. Doel van de verwerking</h2>
              <p className="text-base leading-7 text-muted-foreground">
                De gegevens worden gebruikt om jouw account te laten werken, inzichten te tonen, functies te
                personaliseren, beveiliging te verbeteren en verzoeken of vragen te beantwoorden.
              </p>
            </section>

            <section className="space-y-3">
              <h2 className="font-heading text-xl font-semibold leading-tight sm:text-2xl">3. Bewaartermijnen en beveiliging</h2>
              <p className="text-base leading-7 text-muted-foreground">
                Gegevens worden niet langer bewaard dan nodig is voor dienstverlening, administratie, beveiliging of
                wettelijke verplichtingen. budgettoppers neemt passende technische en organisatorische maatregelen om
                gegevens te beschermen.
              </p>
            </section>

            <section className="space-y-3">
              <h2 className="font-heading text-xl font-semibold leading-tight sm:text-2xl">4. Jouw rechten</h2>
              <p className="text-base leading-7 text-muted-foreground">
                Je kunt verzoeken doen tot inzage, correctie of verwijdering van persoonsgegevens, voor zover dat past
                binnen toepasselijke wet- en regelgeving en operationele verplichtingen.
              </p>
            </section>

            <section className="space-y-3">
              <h2 className="font-heading text-xl font-semibold leading-tight sm:text-2xl">5. Vragen over privacy</h2>
              <p className="text-base leading-7 text-muted-foreground">
                Voor privacyvragen kun je contact opnemen via de contactpagina. Deze verklaring kan worden bijgewerkt
                wanneer de dienst, processen of wettelijke vereisten wijzigen.
              </p>
            </section>
          </article>

          <aside className="rounded-3xl border border-border bg-muted/30 p-5 sm:p-6">
            <h2 className="font-heading text-xl font-semibold leading-tight">Bedrijfsgegevens</h2>
            <dl className="mt-4 space-y-3 text-sm">
              {companyDetails.map(([label, value]) => (
                <div key={label} className="rounded-2xl border border-border bg-white px-4 py-3 text-left">
                  <dt className="text-xs uppercase tracking-[0.14em] text-muted-foreground">{label}</dt>
                  <dd className="mt-1 break-words text-sm font-medium leading-6 text-foreground">{value}</dd>
                </div>
              ))}
            </dl>
          </aside>
        </div>
      </main>
    </div>
  );
}
